import type { SimpleVehicleProps } from '../types/types'

export function searchVehicles(vehicles: SimpleVehicleProps[], search: string): SimpleVehicleProps[] {
  const query = search.trim().toLowerCase()
  if (!query) return vehicles

  return vehicles.filter(
    (vehicle) =>
      (vehicle.year ? vehicle.year.toString() : '').includes(query) ||
      (vehicle.status || '').toLowerCase().includes(query) ||
      (vehicle.driverName || '').toLowerCase().includes(query) ||
      (vehicle.registrationNumber || '').toLowerCase().includes(query) ||
      (vehicle.make || '').toLowerCase().includes(query) ||
      (vehicle.model || '').toLowerCase().includes(query) ||
      (vehicle.accountNo || '').toLowerCase().includes(query) ||
      (vehicle.budgetNo || '').toLowerCase().includes(query),
  )
}
